"use client";

import { SubmitButton } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";

interface ExistingUserAcceptProps {
  email: string;
  orgName: string;
  pending: boolean;
  onAccept: () => void;
}

export function ExistingUserAccept({
  email,
  orgName,
  pending,
  onAccept,
}: ExistingUserAcceptProps) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-contrast/70 leading-5">
        You&apos;re signed in as{" "}
        <span className="text-heading font-medium">{email}</span>. Accepting
        this invite will add you to {orgName}.
      </p>
      <SubmitButton
        type="button"
        variant="light"
        size="auth"
        loading={pending}
        disabled={pending}
        onClick={onAccept}
      >
        Join {orgName} <Icon name="IconArrowRight" size={16} />
      </SubmitButton>
    </div>
  );
}
